/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

export const coverageColumns = [
  {
    label: "Coverage",
    value: "coverage",
  },
  {
    label: "Coverage Type",
    value: "coverageType",
  },
  {
    label: "Premium Net",
    value: "premiumNet",
  },
  {
    label: "Limit",
    value: "limit",
  },
  {
    label: "Deductible",
    value: "deductible",
  },
  {
    label: "Rate",
    value: "rate",
  },
  {
    label: "Tax Rate",
    value: "taxRate",
  },
  {
    label: "Max Period",
    value: "maxPeriod",
  },
  {
    label: "Deductible Description",
    value: "deductibleDescription",
  },
  {
    label: "Max Limit Claim Rate",
    value: "maxLimitClaimRate",
  },
  {
    label: "ACTION",
    value: "ACTION",
    right: true,
  },
];
